import { DateTime } from 'luxon';

/** What moment accepted as an input and the app still passes around. */
export type DateInput = DateTime | Date | string | number | null | undefined;

/** moment renders any unparseable input as this string. */
export const INVALID_DATE = 'Invalid date';

/**
 * Coerces the date shapes that reach the UI into a Luxon DateTime.
 *
 * Several API contracts type these fields as `Date` while the values arrive as ISO strings from
 * JSON — `RouteSummary.scheduledStart` is read with a cast for that reason in
 * `DispatcherService.canStartRoute`. Moment accepted every shape; Luxon needs the right entry
 * point per shape, so callers coerce here first.
 *
 * `undefined` resolves to the current time, which is what `moment(undefined)` did.
 */
export function toDateTime(value: DateInput): DateTime {
  if (value === undefined) { return DateTime.now(); }
  if (value === null) { return DateTime.invalid('no value'); }
  if (DateTime.isDateTime(value)) { return value; }
  if (value instanceof Date) { return DateTime.fromJSDate(value); }
  if (typeof value === 'number') { return DateTime.fromMillis(value); }
  return DateTime.fromISO(value);
}
